import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import EmailCapturePDP from "web/react/components/email-capture-pdp/email-capture-pdp";
import ProductDescriptionHeader from "web/react/components/product-description/product-description-header/product-description-header";
import ProductDescriptionPriceFB from "web/react/components/product-description/product-description-price-fb/product-description-price-fb";
import ProductDescriptionShipping from "web/react/components/product-description/product-description-shipping/product-description-shipping";
import { gettext } from "web/script/modules/django-i18n";
import { BuyOptionPropType } from "web/types/buy-option";
import { DesignerPropType } from "web/types/designer";
import { ProductPropType } from "web/types/product";
import styles from "./product-area-fb.css";


function ProductAreaFB({
    buy_options: buyOptions,
    product,
    designer,
    absolute_url: absoluteUrl,
    is_saved_for_later: isSavedForLater,
    sorted_buy_options: sortedBuyOptions,
    terms_url: termsUrl,
    is_product_area_accordions_enabled: isProductAreaAccordionsEnabled,
    email_capture: emailCapture,
}) {
    let buyOption = buyOptions[sortedBuyOptions[0]];
    let size = buyOption.sizes[buyOption.default_size];

    let currentPriceHtml = size.formatted_sale_price_with_html;
    let priceWithCurrencySymbol = size.formatted_price;

    let selectedShipping;
    let freeShipping;
    let expressShipping;
    let freeReturn = false;
    if (size.returns) {
        freeReturn = size.returns.is_free;
    }
    if (size.shipping_info) {
        let { cheapest, cheapest_guaranteed: guaranteed, fastest } = size.shipping_info;
        if (cheapest && cheapest.is_free) {
            freeShipping = cheapest;
        }
        if (guaranteed) {
            selectedShipping = guaranteed;
        } else {
            selectedShipping = cheapest;
        }
        expressShipping = fastest;
    }
    let shouldRenderShipping = freeShipping || expressShipping || freeReturn;

    let promotion;
    if (size.promotion) {
        let promo = size.promotion;
        let retailerTerms = promo.terms_url;
        if (!retailerTerms) {
            retailerTerms = size.lead_url;
        }
        promotion = {
            tcs: [
                {
                    message: gettext("in_stock_product.lyst_promotion_terms_link"),
                    url: termsUrl,
                },
                {
                    message: gettext("in_stock_product.retailer_promotion_terms_link", {
                        retailer_name: buyOption.retailer_name,
                    }),
                    url: retailerTerms,
                },
            ],
            message: promo.html_message,
            url: promo.url,
        };
    }


    return (
        <div>
            <ProductDescriptionHeader
                absoluteUrl={absoluteUrl}
                className={styles.headerArea}
                designerName={designer.name}
                designerUrl={designer.url}
                isDesignerActive={designer.active}
                productId={product.product_id}
                shortDescription={product.short_description}
            />
            <ProductDescriptionPriceFB
                absoluteUrl={absoluteUrl}
                className={classnames(styles.priceArea)}
                currentPriceHtml={currentPriceHtml}
                isOnSale={size.is_on_sale}
                isSavedForLater={isSavedForLater}
                leadUrl={size.lead_url}
                priceWithCurrencySymbol={priceWithCurrencySymbol}
                promotion={promotion}
                retailerName={buyOption.retailer_name}
                selectedShipping={selectedShipping}
            />

            {shouldRenderShipping && (
                <ProductDescriptionShipping
                    productAreaAccordions={isProductAreaAccordionsEnabled}
                    isSavedForLater={isSavedForLater}
                    leadUrl={size.lead_url}
                    retailerName={buyOption.retailer_name}
                    freeShipping={freeShipping}
                    freeReturn={freeReturn}
                    expressShipping={expressShipping}
                    className={styles.shippingArea}
                />
            )}

            <EmailCapturePDP
                privacyPolicyLink={emailCapture.privacyPolicyLink}
                termsAndConditionsLink={emailCapture.termsAndConditionsLink}
                cookiePolicyLink={emailCapture.cookiePolicyLink}
                shortEUPolicy={emailCapture.shortEUPolicy}
                productId={emailCapture.productId}
            />
        </div>
    );
}

export default ProductAreaFB;

ProductAreaFB.propTypes = {
    buy_options: PropTypes.objectOf(BuyOptionPropType).isRequired,
    product: ProductPropType.isRequired,
    designer: DesignerPropType.isRequired,
    absolute_url: PropTypes.string.isRequired,
    is_saved_for_later: PropTypes.bool.isRequired,
    sorted_buy_options: PropTypes.arrayOf(PropTypes.string).isRequired,
    terms_url: PropTypes.string.isRequired,
    is_product_area_accordions_enabled: PropTypes.bool.isRequired,
    email_capture: PropTypes.shape({
        privacyPolicyLink: PropTypes.string,
        termsAndConditionsLink: PropTypes.string,
        cookiePolicyLink: PropTypes.string,
        shortEUPolicy: PropTypes.bool,
        productId: PropTypes.string,
    }),
};
